import { isQuizKind, QuizCategory, QuizKind } from '@/models/Quiz';

export class QuizCategoryInfoDTO {
  category!: QuizCategory;
  displayName!: string;
  kind!: QuizKind;
}

/** Pozycja z `GET /quiz` — pozwala zbudować listę oświadczeń bez zaszytej listy kategorii w kodzie. */
export class QuizCategoryInfo extends QuizCategoryInfoDTO {
  constructor(quizCategoryInfoDTO?: QuizCategoryInfoDTO) {
    super();
    Object.assign(this, quizCategoryInfoDTO);
  }

  public get isOneOff(): boolean {
    return isQuizKind(this.kind, QuizKind.ONE_OFF);
  }
}

export class QuizTestDTO {
  category!: QuizCategory;
  version!: number;
  questions!: Array<QuizQuestion>;
  requiredCorrectAnswers!: number;
}

export class QuizTest extends QuizTestDTO {
  constructor(quizTestDTO?: QuizTestDTO) {
    super();
    if (quizTestDTO) {
      quizTestDTO.questions = quizTestDTO.questions.map(x => new QuizQuestion(x));
    }
    Object.assign(this, quizTestDTO);
  }
}

export class QuizQuestionDTO {
  text!: string;
  answers!: Array<string>;
  label?: string;
}

export class QuizQuestion extends QuizQuestionDTO {
  answer!: number;
  constructor(quizQuestionDTO?: QuizQuestionDTO) {
    super();
    Object.assign(this, quizQuestionDTO);
  }
}

export class QuizAnswerDTO {
  questionIndex!: number;
  answerIndex!: number;
}

export class QuizAnswer extends QuizAnswerDTO {
  constructor(quizAnswerDTO?: QuizAnswerDTO) {
    super();
    Object.assign(this, quizAnswerDTO);
  }
}

export class QuizUserDTO {
  id!: number;
  firstName!: string;
  lastName!: string;
  email!: string;
  isHrLocked!: boolean;
  photoUrl?: string;
}

export class QuizUser extends QuizUserDTO {
  constructor(quizUserBodyDTO?: QuizUserDTO) {
    super();
    Object.assign(this, quizUserBodyDTO);
  }

  public get displayName(): string {
    return (this.firstName || this.lastName) ? `${this.firstName} ${this.lastName || ''}` : '';
  }

  public get initials(): string {
    return this
      .displayName
      .split(' ')
      .map(el => el[0])
      .join('')
      .toUpperCase();
  }
}

export class QuizTestBodyDTO {
  quizCategory!: QuizCategory;
  quizVersion!: number;
  answers!: Array<QuizAnswer>;
}

export class QuizTestBody extends QuizTestBodyDTO {
  constructor(quizTestBodyDTO?: QuizTestBodyDTO) {
    super();
    Object.assign(this, quizTestBodyDTO);
  }
}

export class QuizTestAttemptDTO {
  answers!: Array<QuizAnswer>;
  correctAnswers!: number;
  id!: number;
  isResultPositive!: boolean;
  numberOfQuestions!: number;
  quizCategory!: QuizCategory;
  quizVersion!: number;
  takenAt!: string;
  userId!: number;
  user!: QuizUser;
  hrLockAt!: string;
  allowReattemptAt!: string;
}

export class QuizTestAttempt extends QuizTestAttemptDTO {
  constructor(quizTestAttemptDTO?: QuizTestAttemptDTO) {
    super();
    Object.assign(this, quizTestAttemptDTO);
  }

  public get displayName(): string {
    return (this.user.firstName || this.user.lastName) ? `${this.user.firstName} ${this.user.lastName || ''}` : '';
  }

  public get initials(): string {
    return this.displayName.split(' ').map(el => el[0]).join('').toUpperCase();
  }

  public get score(): number {
    return Math.round((this.correctAnswers / this.numberOfQuestions) * 100);
  }
}
